import { createContext, useContext, useEffect } from 'react';

/**
 * Fil d'Ariane de la topbar : une page de détail (joueur, tournoi…) y publie le nom de ce qu'elle affiche,
 * à la place du « Détail » générique. Le shell (ErpShell) fournit le setter ; hors shell, le hook ne fait rien.
 */
export const BreadcrumbDetailContext = createContext(null);

/** `parent` (facultatif) : niveau intermédiaire entre la page et le détail, `{ label, to }` (ex. Boutique › Abonnements ›
 * nom). Les pages de détail n'ont pas de lien retour en plus : le fil d'Ariane en tient lieu. */
export function useBreadcrumbDetail(label, parent = null) {
  const setDetail = useContext(BreadcrumbDetailContext);
  const parentLabel = parent?.label || null;
  const parentTo = parent?.to || null;
  useEffect(() => {
    if (!setDetail) return undefined;
    setDetail(label || parentLabel ? { label: label || null, parent: parentLabel && parentTo ? { label: parentLabel, to: parentTo } : null } : null);
    return () => setDetail(null);
  }, [setDetail, label, parentLabel, parentTo]);
}
